import { FrequencyType } from '@wix/ambassador-bookings-services-v2-service/types';
function calcElapsedMonths(startDate, now) {
  const yearDiff = now.getUTCFullYear() - startDate.getUTCFullYear();
  return yearDiff * 12 + (now.getUTCMonth() - startDate.getUTCMonth());
}
export const getSubscriptionDisplayInfo = (subscription, options) => {
  const {
    amountPerBillingCycle,
    totalPayments,
    recurringStartDate
  } = subscription;
  if (!amountPerBillingCycle || totalPayments === null || totalPayments === undefined || !recurringStartDate) {
    return null;
  }
  const now = (options == null ? void 0 : options.now) ?? new Date();
  const startDate = new Date(recurringStartDate);
  const isStarted = now >= startDate;
  let remainingPayments;
  if (!isStarted) {
    remainingPayments = totalPayments;
  } else {
    remainingPayments = Math.max(1, totalPayments - calcElapsedMonths(startDate, now));
  }
  const enrollmentFee = subscription.enrollmentFeeAmount;
  const hasEnrollmentFee = !!(enrollmentFee != null && enrollmentFee.value) && Number(enrollmentFee.value) > 0;
  return {
    amountPerCycle: amountPerBillingCycle,
    totalPayments,
    remainingPayments,
    isStarted,
    startDate,
    hasEnrollmentFee,
    enrollmentFee: hasEnrollmentFee ? enrollmentFee : undefined,
    frequency: subscription.frequency ?? FrequencyType.MONTHLY
  };
};

/**
 * How many payments a customer who joins now will make: all of them before the start date,
 * the ones left after it (at least one). Undefined when the subscription has no end.
 */
export const getRemainingPayments = (subscription, options) => {
  var _getSubscriptionDispl;
  return ((_getSubscriptionDispl = getSubscriptionDisplayInfo(subscription, options)) == null ? void 0 : _getSubscriptionDispl.remainingPayments) ?? subscription.totalPayments ?? undefined;
};

/**
 * How many payments a subscription discount covers, out of the payments left to the customer.
 * Returns undefined when it covers all of them: no cycle count, or one at least the remaining payments.
 */
export const getDiscountedPaymentsCount = (discountedCycleCount, remainingPayments) => discountedCycleCount == null || remainingPayments !== undefined && discountedCycleCount >= remainingPayments ? undefined : discountedCycleCount;
//# sourceMappingURL=subscription.js.map